import loadDependencies from './import-dependencies'
import mapDependencies from './mapDependencies'
import mapParams from './mapParams'

const insertNewImportMap = (newMapJSON) => {
  const map = document.querySelector('script[type="systemjs-importmap"]')
  map.text = JSON.stringify(newMapJSON)
}

const insertNewScriptTag = ({ src, type }) => {
  const element = document.createElement('script')
  element.type = type
  element.src = src

  document.querySelector('body').appendChild(element)
}

const registerDependencies = ({ environment, config }) => {
  const { DEPENDENCIES, WEB_COMPONENTS_URL } = config
  let deps = []

  let params = null

  if (environment !== 'production') {
    const { search } = window.location
    params = mapParams(search)
  }

  deps = loadDependencies({ DEPENDENCIES, params })

  insertNewImportMap(mapDependencies(deps))
  insertNewScriptTag({ src: WEB_COMPONENTS_URL, type: 'module' })
}

export default registerDependencies
